import { z } from 'zod'

export const ssoSubject = z.tuple([z.literal('access'), z.literal('Sso')])

export type SsoSubject = z.infer<typeof ssoSubject>
